"use client";

import { DocumentUploader } from "@/components/DocumentUploader";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText } from "lucide-react";

const DocumentsPage = () => {
  return (
    <div className="container mx-auto p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold flex items-center space-x-2">
          <FileText className="h-8 w-8" />
          <span>Documents</span>
        </h1>
      </div>
      <DocumentUploader />
    </div>
  );
};

export default DocumentsPage;